import React from 'react';
import Layout from '../../../../components/Layout/Layout';
import HazardProtectionStatusWidget from '../../../../components/Widget/HazardProtectionStatusWidget';
import HazardSurveysPendingReviewWidget from '../../../../components/Widget/HazardSurveysPendingReviewWidget';
import DashboardWidget from '../../../../components/Widget/DashboardWidget';
import { Box, Flex } from 'rebass';

function HazardDashboard(): JSX.Element {
  return (
    <Layout>
      <Flex
        flexGrow={1}
        sx={{
          overflow: 'auto',
          padding: '20px',
        }}
        flexDirection="row"
      >
        <Box
          flexGrow={1}
          sx={{
            display: 'grid',
            gridTemplateColumns: [
              'repeat(1, 1fr)',
              'repeat(1, 1fr)',
              'repeat(2, 1fr)',
              'repeat(3, 1fr)',
            ],
            gridAutoRows: 'calc(50% - 10px)',
            gridGap: '20px',
          }}
        >
          <DashboardWidget
            title="Water Service Hazard Status"
            component={HazardProtectionStatusWidget}
          />
          <DashboardWidget
            title="Hazard Surveys"
            subtitle="Pending Review"
            component={HazardSurveysPendingReviewWidget}
          />
        </Box>
      </Flex>
    </Layout>
  );
}

export default HazardDashboard;
